import { store } from '../'
import { router } from '../../app';
import { Vue } from 'vue';

const state = () => ({
    productFetchError: '',
    productSku: null, 
    id: '[WEB_W010]',
    receipt: null,
    cost: null,
    description: null,
    purchaseDate: null,
    allocation: null,
    vendor: null,
    vendorLocation: null,
    vendorItemId: null,
    buyTeam: null,
    buyers: [],
    comment: null,
    productName: null,
    productSku: null,
    brand: null,
    gender: null,
    material: null,
    style: null,
    category: null,
    styleNumber: null,
    subcategory: null,
    colorFamily: null,
    size: null,
    msrp: null,
    currentPrice: null,
    adjustedMargin: null,
    addedDiscount: null,
    itemDescription: null,
    condition: null,
    origin: null,
    color: null,
    serial: null,
    core: null,
    iconic: null,
    extras: [],
    availableExtras: [],
    itemPreset: null,
    itemStyleNumber: null,
    additionalDescription: null,
    margin: null,
    retail: null,
    shelfName: null,
    itemAge: null,
    vendorSku: null,
    retailSales: null,
    retailSalesVelocity: null,
    vendorCost: null,
    msrpDiscount: null,
    itemBuyer: null,
    currentImage:1,

    productImages:[
        /*{
            id: 1,  
            large: 'images/testitem/QGJ0U61MEB002_1.webp',
            thumb: 'images/testitem/QGJ0U61MEB002_1.webp'
        },
        {
            id: 2,  
            large: 'images/testitem/QGJ0U61MEB002_2.webp',
            thumb: 'images/testitem/QGJ0U61MEB002_2.webp'
        },
        {
            id: 3,  
            large: 'images/testitem/qgj0u602nf000_1.webp',
            thumb: 'images/testitem/qgj0u602nf000_1.webp'
        },
        {
            id: 4,  
            large: 'images/testitem/qgj0u602nf000_2.webp',
            thumb: 'images/testitem/qgj0u602nf000_2.webp'
        }*/
    ],
    productImageSrc: null,
    validationGroups: null,
    lOA: null,
    lOANumber: ''
    

    
});
const getters = {
    pageTitle: state => state.pageTitle,
    productImageSrc: state => state.productImageSrc,
    openMenu: state => state.openMenu,
    currentProduct: state => state.currentProduct,
    currentPrice: state => state.currentPrice,
    adjustedMargin: state => state.adjustedMargin,
    addedDiscount: state => state.addedDiscount,
    pricing: state => state.pricing,
    currentProductAttributes: state => state.attributes,
    currentProductEditHistory: state => state.editHistory,
    productImages: state => state.productImages,
    productFetchError: state => state.productFetchError,
    receipt: state => state.receipt,
    allocation: state => state.allocation,
    cost: state => state.cost,
    purchaseDate: state => state.purchaseDate,
    vendor: state => state.vendor,
    vendorLocation: state => state.vendorLocation,
    vendorItemId: state => state.vendorItemId,
    buyTeam: state => state.buyTeam,
    buyers: state => state.buyers,
    itemBuyer: state => state.itemBuyer,
    comment: state => state.comment,
    productName: state => state.productName,
    productSku: state => state.productSku,
    brand: state => state.brand,
    gender: state => state.gender,
    material: state => state.material,
    style: state => state.style,
    category: state => state.category,
    styleNumber: state => state.styleNumber,
    subcategory: state => state.subcategory,
    colorFamily: state => state.colorFamily,
    size: state => state.size,
    msrp: state => state.msrp,
    itemDescription: state => state.itemDescription,
    description: state => state.description,
    condition: state => state.condition,
    origin: state => state.origin,
    color: state => state.color,
    serial: state => state.serial,
    extras: state => state.extras,
    core: state => state.core,
    iconic: state => state.iconic,
    availableExtras: state => state.availableExtras,
    itemPreset: state => state.itemPreset,
    itemStyleNumber: state => state.itemStyleNumber,
    additionalDescription: state => state.additionalDescription,
    name: state => state.name,
    attributes: state => state.attributes,
    id: state => state.id,
    validationGroups: state => state.validationGroups,
    margin: state => state.margin,
    retail: state => state.retail,
    shelfName: state => state.shelfName,
    itemAge: state => state.itemAge,
    vendorSku: state => state.vendorSku,
    retailSales: state => state.retailSales,
    retailSalesVelocity: state => state.retailSalesVelocity,
    vendorCost: state => state.vendorCost,
    msrpDiscount: state => state.msrpDiscount,
    currentImage: state => state.currentImage,
    lOA: state => state.lOA,
    lOANumber: state => state.lOANumber


};
const mutations = {
    updateState(state, payload){ 
        //console.log('mutation called: '+ payload.field + ' = ' + payload.value);
        state[payload.field] = payload.value 
        if(payload.field == 'productCollection'){
            //console.log('update storage - ' + JSON.stringify(payload.value));
            localStorage.setItem('productList', JSON.stringify(payload.value));
        }
    },
    setFetchError(state, error){
        state.productFetchError = error;
    },
    storeProduct(state, value){
        localStorage.setItem('selectedProduct', value);
        state.selectedProduct = value;
    },
    addToProduct(state, payload){
        //console.log('got to addToProduct: name = '+payload.itemName+', value = '+payload.value);
        var nameValue = payload.itemName;
        var itemValue = payload.value;
        this.$set(state.selectedProduct, nameValue, itemValue);
    }
};
const actions = {
    set({commit, state, dispatch}, payload){ 
        //console.log('action called: '+ payload.field + ' = ' + payload.value);
        commit('updateState', {field: payload.field, value: payload.value})
        store.dispatch('ProductCollection/updateItem', {sku: state.productSku, field: payload.field, value: payload.value})
            .then(() => {
                localStorage.setItem('productList', JSON.stringify(store.state.ProductCollection.productCollection));
            })
            .catch((error) => {
                    console.log('error returning promise: ' + error)
            });
        
    },
    calculatePrice({dispatch, state}, payload){
        //console.log('calculate-price: '+Object.entries(payload))
        let calcCost = state.cost;
        let calcRetail = state.retail ? state.retail : state.msrp;
        if(payload.type == 'Adjusted Margin'){
            var newMargin = payload.value
            var newSalePrice = calcCost / (1 - (newMargin / 100));
            var newDiscount = ((calcRetail - newSalePrice) / calcRetail) * 100;
        }else if(payload.type == 'Added Discount'){
            var newDiscount = payload.value
            var newSalePrice = calcRetail - (calcRetail * (newDiscount / 100));
            var newMargin = ((newSalePrice - calcCost) / newSalePrice) * 100;
        }else if(payload.type == 'Current Price'){
            var newSalePrice = payload.value
            var newMargin = ((newSalePrice - calcCost) / newSalePrice) * 100;
            var newDiscount = ((calcRetail - newSalePrice) / calcRetail) * 100;
        }
        dispatch('set', {field: 'currentPrice', value: parseFloat(newSalePrice).toFixed(0)});
        dispatch('set', {field: 'adjustedMargin', value: parseFloat(newMargin).toFixed(0)});
        dispatch('set', {field: 'addedDiscount', value: parseFloat(newDiscount).toFixed(0)});
    },
    updateImageCollection({commit, state}, payload){
        //console.log('updating Images - ' + Object.entries(payload));
        let currentImageArray = state.productImages;
        let currentLength = state.productImages.length;
        let addedImage = {id: ++currentLength, large: payload, thumb: payload}
        currentImageArray.push(addedImage);
        commit('updateState', {field: 'productImages', value: currentImageArray} )
    },
    updateProductList({commit, state}){
        console.log('update item: - ' + state.productSku)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}